import {
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'
import { ReturnItemContext, SelectedItemsContext } from '../../../Forms/RMAReturnStep/includes'
import { rmaLRPage } from '../constant'
import useGetLRReason from './useGetLRReason'

const useManageActionButton = ({
  orderDetails,
  partSku,
  handleReason,
  tokenCustomerId,
  GTM,
}) => {
  const [page, setPage] = useState(rmaLRPage.detail)
  const [returnId, setReturnId] = useState('')
  const [submitLoading, setSubmitLoading] = useState(false)

  const {
    getSteps,
    setPayload,
    postApplication,
    patchApplication,
    putApplication,
    setGTMPayload,
  } = { ...handleReason }
  const { returnRequest } = { ...GTM }

  const {
    parts,
    customers_email_address: emailAddress,
    merchant_order_id: merchantOrderId,
    order_id: orderId,
    order_status: orderStatus,
  } = { ...orderDetails }

  const item = useMemo(() => parts?.find(data => data.sku === partSku),
    [partSku, parts])

  const { returnQty } = useContext(ReturnItemContext)
  const selectedItemsContextData = useContext(SelectedItemsContext)
  const { orderItems, setOrderItems } = selectedItemsContextData

  const getReason = useGetLRReason({ item, getSteps })

  const getApplicationData = useMemo(() => ({
    email: emailAddress,
    id: tokenCustomerId,
    orderId,
    orderStatus,
    merchantOrderId,
  }),
  [
    merchantOrderId,
    emailAddress,
    tokenCustomerId,
    orderId,
    orderStatus,
  ])

  const getOrderItem = useCallback(reasons => [...orderItems, {
    ...item,
    displayChatBox: false,
    returnQty,
    images: [],
    reasons: reasons ? [reasons] : [],
    comment: '',
    documents: [],
    isLifetimeReplacementFLag: true,
  }], [item, orderItems, returnQty])

  const registerReturn = useCallback(async () => {
    const initItem = getOrderItem()
    const putPayloadData = setPayload(initItem, getApplicationData, 'PUT')
    await putApplication(putPayloadData)
  }, [getApplicationData, getOrderItem, putApplication, setPayload])

  const manualSetLRReason = useCallback(async () => {
    const step1 = await getReason()
    const items = getOrderItem(step1)
    setOrderItems(items)

    return items
  }, [setOrderItems, getReason, getOrderItem])

  const submitReturn = useCallback(async items => {
    const patchPayloadData = setPayload(items, getApplicationData, 'PATCH')
    await patchApplication(patchPayloadData)

    const postPayloadData = setPayload(items, getApplicationData, 'PATCH')
    const { returnRequestId } = await postApplication(
      postPayloadData, [], [],
    )
    if (returnRequestId) {
      const payloadGTM = setGTMPayload(items, getApplicationData)
      returnRequest(payloadGTM)
    }

    return returnRequestId
  }, [
    getApplicationData,
    postApplication,
    patchApplication,
    setPayload,
    returnRequest,
    setGTMPayload,
  ])

  const submitForm = useCallback(async () => {
    setSubmitLoading(true)
    await registerReturn()
    const items = await manualSetLRReason()
    const returnRequestId = await submitReturn(items)
    setReturnId(returnRequestId)
    setPage(rmaLRPage.confirmation)
    setSubmitLoading(false)
  }, [
    manualSetLRReason,
    registerReturn,
    submitReturn,
  ])

  return {
    page,
    returnId,
    submitForm,
    submitLoading,
  }
}

export default useManageActionButton
